import type { FirebaseApp } from 'firebase/app'
import type { Messaging } from 'firebase/messaging'
import { initializeApp } from 'firebase/app'
import { getMessaging } from 'firebase/messaging'
import { ref } from 'vue'

/**
 * Firebase composable for Nuxt
 */
export function useFirebase() {
  const firebaseApp = ref<FirebaseApp | null>(null)
  const messaging = ref<Messaging | null>(null)

  // Firebase configuration with hardcoded values
  const firebaseConfig = {
    apiKey: 'AIzaSyDio7Thj_lKdfGd3sJ_76Oe4Hgoh8-9iMI',
    authDomain: 'kvest-618b4.firebaseapp.com',
    projectId: 'kvest-618b4',
    storageBucket: 'kvest-618b4.firebasestorage.app',
    messagingSenderId: '337392100316',
    appId: '1:337392100316:web:22ada3902f0067f005e519',
  }

  // Web Push VAPID key
  const vapidKey = 'BDQaZdf3elx4dFjKlgA0gQELoe-zOVM-DwOrMQso1mpvsxULtGNtDuH_AC5NQyZFseaWVufxNAaxnhQiZhr2pAY'

  // Initialize Firebase only on client side
  const initializeFirebase = () => {
    if (!firebaseApp.value && typeof window !== 'undefined') {
      try {
        firebaseApp.value = initializeApp(firebaseConfig)
        messaging.value = getMessaging(firebaseApp.value)
      }
      catch (error) {
        console.error('Firebase initialization error:', error)
      }
    }
    return { app: firebaseApp.value, messaging: messaging.value }
  }

  return {
    initializeFirebase,
    firebaseApp,
    messaging,
    vapidKey,
  }
}
